import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";

export default function PasswordResetSent() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 2,
        background: "linear-gradient(135deg, #87CEFA 0%, #4682B4 100%)",
      }}
    >
      <Card
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 440,
          borderRadius: 4,
          p: 1,
          backgroundColor: "rgba(255,255,255,0.25)",
          boxShadow:
            "0 10px 30px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.25)",
          backdropFilter: "blur(12px)",
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography variant="h6" color="#FFFFFF" sx={{ fontWeight: 600, mb: 2 }}>
            Check your email
          </Typography>
          <Typography color="rgba(255,255,255,0.95)" paragraph>
            If an account exists for that address, we sent a link to reset your
            password. The link expires after a while for security.
          </Typography>
          <Button
            component={RouterLink}
            to="/login"
            variant="contained"
            fullWidth
            sx={{
              mt: 1,
              py: 1.2,
              borderRadius: 2.5,
              fontWeight: 600,
              background:
                "linear-gradient(135deg, #1E90FF 0%, #00BFFF 100%)",
            }}
          >
            Back to sign in
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
